import { ProgramDataHelper } from "@share/program/helpers/ProgramDataHelper";
import { SignalRMethod } from "@api/repositories/reatime-repository/types";

export abstract class ObserversBase {
    method: SignalRMethod;

    constructor(
        protected readonly programDataHelper: ProgramDataHelper
    ) { }

    handler(message: string) { return; }
}
